/* import __COLOCATED_TEMPLATE__ from './help-center-website-turned-on-notification.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();